import { z } from 'zod';

export const formSchema = z.object({
  material: z.string().optional(),
  plannerId: z.string().optional(),
  materialDescription: z.string().optional(),
  batch: z.string().optional(),
  productReasonTypeId: z.string().optional(),
  totalValue: z.string().optional(),
  shelfLifeExpirationDate: z.string().optional(),
  storageLocation: z.string().optional(),
  destinationPlant: z.string().optional(),
});

export type FormSchema = z.infer<typeof formSchema>;